
import { Modal } from "@mui/material";
import { Typography } from "components/ui";
import { motion } from "framer-motion";
import React from "react";
import CardHeader from "./components/CardHeader";
import CardTable from "./components/CardTable";
import RulePanel from "./components/RulePanel";
import useCardGame from "./hooks/useCardGame";
import { ContainerStyle, ModalContainer, SectionStyle } from "./styled";

export default (props) => {
  const { duration } = props;
  const {
    face,
    suit,
    describe,
    setDescribe,
    guide,
    setGuide,
    deck,
    count,
    modal,
    controls,
    onDraw,
    onReset,
    onCloseModal,
  } = useCardGame();

  return (
      <motion.div
        initial={{ x: -10, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 10, opacity: 0 }}
        transition={{ duration: duration }}
        style={{ height: "100%" }}
      >
    <ContainerStyle sx={{ textAlign: "center" }}>
        <Modal open={modal.value} onClose={onCloseModal}>
          <ModalContainer>
            <Typography $center $size="4em">
              {"K ใบสุดท้าย หมด 1 ช็อตหรือ 1 แก้ว"}
            </Typography>
          </ModalContainer>
        </Modal>

        <SectionStyle>
          <CardHeader
            deckLength={deck.length}
            count={count}
            onReset={onReset}
          />
          <CardTable
            controls={controls}
            face={face}
            suit={suit}
            onDraw={onDraw}
            setDescribe={setDescribe}
            setGuide={setGuide}
          />
          <RulePanel describe={describe} guide={guide} />
        </SectionStyle>
    </ContainerStyle>
      </motion.div>
  );
};
